import * as types from '../constants/ActionTypes';

const localStorageKey = 'novasol-data';

const localStorageSyncer = ({dispatch, getState}) => next => (action) => {
  const returnValue = next(action);
  if (action.type === types.INIT_FROM_DRUPAL) {
    try {
      const storedState = JSON.parse(window.localStorage.getItem(localStorageKey));
      const currentState = getState();
      if (storedState && currentState.orderAppState.propertyId
        && currentState.orderAppState.propertyId === storedState.orderAppState.propertyId
        && currentState.orderAppState.adults === storedState.orderAppState.adults
        && currentState.orderAppState.children === storedState.orderAppState.children
        && currentState.orderAppState.arrivalDate === storedState.orderAppState.arrivalDate
        && currentState.orderAppState.departureDate === storedState.orderAppState.departureDate
        && currentState.orderAppState.salesMarket === storedState.orderAppState.salesMarket
        && currentState.orderAppState.company === storedState.orderAppState.company
        && currentState.orderAppState.agency.agencyNumber === storedState.orderAppState.agency.agencyNumber
      ) {

        // PayPal and iDeal should have unique orderid every time we send to dibs
        if (storedState.orderAppState.payment.paymentOptionSelected.match(/(PayPal|ABN)/)) {
          storedState.orderAppState.orderTokenId = currentState.orderAppState.orderTokenId;
        }

        // Hotfix: don't load dibsForm.
        storedState.appearanceAppState.dibsFormArgs = [];

        return dispatch({
          type: types.RESET_STATE,
          payload: storedState,
        });
      }
      window.localStorage.removeItem(localStorageKey);
    }
    catch (e) {
      console.log(e); // eslint-disable-line no-console
    }
  }
  else if (action.type === types.UPDATE_GUEST_OPTIONS) {
    let regex;
    if (action.payload.propertyName === 'adults') {
      regex = /(NA=(\d+))(&|$)/g;
    }
    else if (action.payload.propertyName === 'pets') {
      regex = /(NP=(\d+))(&|$)/g;
    }
    else {
      regex = /(NC=(\d+))(&|$)/g;
    }
    const matches = regex.exec(window.document.location.href);
    if (matches && window.history.replaceState) {
      // When we come to the first step page, order is being built from URL params, that usually has 0 for guests,
      // but then we could go back and change number of adults on www.novasol.com and come back and according to
      // rules above if adults cound is different we should no use cached version of user input. These lines were
      // added to fix this problem together with problem of going back in history from dibs.
      const href = window.document.location.href.replace(matches[1],
        matches[1].replace(matches[2],
          action.payload.value));
      window.history.replaceState({},
        document.title,
        href);
    }
  }

  return returnValue;
};

const localStorageSaver = ({getState}) => next => (action) => {
  if ([types.INIT_FROM_DRUPAL, types.RESET_STATE].indexOf(action.type) > -1) {
    return next(action);
  }
  try {
    window.localStorage.setItem(localStorageKey,
      JSON.stringify(getState()));
  }
  catch (e) {
    console.log(e); // eslint-disable-line no-console
  }
  return next(action);
};

export {
  localStorageSyncer,
  localStorageSaver,
};
